const md5 = require('../../../../utils/md5');
const BaseView = require('./abstract/template');
const ProjectFacade = require('../../../../facade/project/project');
const UserInfoFactory = require('../../../../factory/user-info');
const RestrictionsFactory = require('../../../../factory/restrictions');

module.exports = BaseView.extend({
  height: null,
  setLoaded: false,
  template: require('./templates/template.hbs'),
  designAddedEvent: 'template.update.restricted',

  events: {
    'click .base': 'addEvent',
    'click .options li[data-type="this-page"]': 'addToCurrentPageEvent',
    'click .options li[data-type="new-page"]': 'addToNewPageEvent',

    'click .set .set-page': 'addPageEvent',
    'click .set .close': 'closeSetEvent'
  },

  closeSetEvent: function () {
    this.toggleSet(false);
  },

  isCanvasMainTagEmpty: function () {
    return !INKIVE.DesignFacade.get().filter(element => element.id !== 'background').length;
  },

  togglePopupOnAddOrReplaceTemplate: function (event) {
    const target = event.currentTarget;

    if (target.dataset.type === 'this-page') {
      this.isCanvasMainTagEmpty()
        ? this._addToCurrentPageEvent(event)
        : this.displayModalConfirm(event, _.bind(this._addToCurrentPageEvent, this));
    } else if (target.dataset.type === 'new-page') {
      this.isCanvasMainTagEmpty()
        ? this._addToNewPageEvent(event)
        : this.displayModalConfirm(event, _.bind(this._addToNewPageEvent, this));
    }
  },

  addToCurrentPageEvent: function (event) {
    const isLocked = this.baseTemplate.is_premium && !this.canUse;

    event.stopPropagation();

    isLocked
      ? this.displayLockedTemplateModal()
      : this.togglePopupOnAddOrReplaceTemplate(event);
  },

  addToNewPageEvent: function (event) {
    const isLocked = this.baseTemplate.is_premium && !this.canUse;

    event.stopPropagation();
    isLocked
      ? this.displayLockedTemplateModal()
      : this.togglePopupOnAddOrReplaceTemplate(event);
  },

  addEvent: function (event) {
    const isLocked = this.baseTemplate.is_premium && !this.canUse;

    isLocked
      ? this.displayLockedTemplateModal()
      : this._addEvent(event);
  },

  _addToCurrentPageEvent: function (event) {
    this.setTemplate(this.getPageDataFromEvent(event));
  },

  displayModalConfirm: function (event, callback) {
    if (localStorage.getItem('modalRestrictedTemplateConfirmDontShowAgain') === 'true' ||
      INKIVE.Helpers.getPrintGuidelinesProject()) {
      callback && callback(event);
      return;
    }

    const that = this;
    this.modal = INKIVE.Modal.modalWindow(
      INKIVE.TemplatesHelper('modal_restricted_template_confirm'),
      {
        width: 550,
        height: 250,
        headerIcon: 'icon-cloud-download',
        headerTitle: INKIVE.TranslateHelper.translate('modal.title.apply_template'),
        buttons: [
          {
            title: INKIVE.TranslateHelper.translate('modal.title.add_new_page'),
            cls: 'modal-apply-secondary-template',
            onClick: function () {
              localStorage.setItem('modalRestrictedTemplateConfirmDontShowAgain', $('input#dont-show-again').is(':checked'));

              that.modal.close();
              that._addToNewPageEvent(event);
            }
          },
          {
            title: INKIVE.TranslateHelper.translate('modal.title.replace_current_page'),
            cls: 'modal-apply-secondary-template',
            onClick: function () {
              localStorage.setItem('modalRestrictedTemplateConfirmDontShowAgain', $('input#dont-show-again').is(':checked'));

              that.modal.close();
              callback(event);
            }
          }
        ]
      }
    );
  },

  _addToNewPageEvent: function (event) {
    ProjectFacade.handle('design', 'add', { quiet: true })
      .then(() => this._setTemplate(this.getPageDataFromEvent(event)));
  },

  _addEvent: function (event) {
    if (this.isMultiPage()) {
      this.toggleSet();
    } else {
      this.displayModalConfirm(event, () => this.setTemplate(this.getPageDataFromEvent(event)));
    }
  },

  addPageEvent: function (event) {
    this.setTemplate(this.getPageDataFromEvent(event));
  },

  getPageDataFromEvent: function (event) {
    return {
      page_id: $(event.currentTarget).closest('[data-page-id]').data('page-id'),
      page: $(event.currentTarget).closest('.set-page').index() + 1
    };
  },

  setTemplate: function (pageData = {}) {
    this.page = Number.isInteger(pageData.page) ? pageData.page : 1;
    INKIVE.Modal.togglePageLoader(true);

    // TODO: support restrictions for Desygner
    INKIVE.C.BOOK.book_type === INKIVE.C.BOOK_TYPE.DESYGNER_DESIGN
      ? proceed.call(this)
      : $.when(
        RestrictionsFactory.getTemplatePermissions(),
        RestrictionsFactory.getElementPermissions()
      ).then(
        proceed.bind(this),
        proceed.bind(this)
      );

    function proceed (templatePermissions, elementPermissions) {
      INKIVE.Modal.togglePageLoader(false);
      this.templatePermissions = templatePermissions || [];
      this.elementPermissions = elementPermissions || [];

      const needsConfirmation = INKIVE.C.BOOK.book_type === INKIVE.C.BOOK_TYPE.TEMPLATE &&
      (this.templatePermissions.length || this.templatePermissions.length);

      needsConfirmation ? this.applyTemplateOnSamePage(pageData) : this._setTemplate(pageData);
    }
  },

  displayModalOptions: function () {
    const hasRestrictions = this.templatePermissions.length ||
    this.elementPermissions.length;

    this.modal = INKIVE.Modal.modalWindow(
      INKIVE.TemplatesHelper('modal_restricted_template_load', {
        has_restrictions: hasRestrictions
      }),
      {
        width: 600,
        headerIcon: 'icon-cloud-download',
        headerTitle: 'modal.title.change_name',
        buttons: [
          {
            title: INKIVE.TranslateHelper.translate('modal.buttons.apply_name'),
            cls: 'modal-apply-secondary-template',
            onClick: this.applyTemplateOnSamePage
          }, {
            title: INKIVE.TranslateHelper.translate('general.cancel'),
            cls: 'modal-apply-secondary-template',
            onClick: this.closeModal
          }
        ]
      }
    );
  },

  applyTemplateOnSamePage: function (pageData) {
    const copyRestrictions = this.isCanvasMainTagEmpty()
      ? true
      : $('input[name="copy-restrictions"]').is(':checked');

    const hasRestrictions = this.templatePermissions.length || this.elementPermissions.length;

    this._setTemplate(pageData);

    hasRestrictions && copyRestrictions && this._copyRestrictions();
  },

  // TODO: review + fix
  _copyRestrictions: function () {
    this._copyTemplatePermissions(this.templatePermissions);
    this._copyElementPermissions(this.elementPermissions);
  },

  _copyTemplatePermissions: function (templatePermissions) {
    if (_.size(templatePermissions)) {
      const field = Object.keys(templatePermissions)[0];
      const value = templatePermissions[field];
      return RestrictionsFactory.setGlobalTemplateRestriction(field, value)
        .then(_.bind(this._copyTemplatePermissions, this, _(templatePermissions).omit(field)));
    }

    const deferred = $.Deferred();
    deferred.resolve();
    return deferred.promise();
  },

  _copyElementPermissions: function (elementPermissions) {
    if (_.size(elementPermissions)) {
      const p = elementPermissions.pop();

      return p.page_number === this.page
        ? RestrictionsFactory.setGlobalElementRestriction(p.element_id, p.restrictions)
          .then(_.bind(this._copyTemplatePermissions, this, elementPermissions))
        : this._copyTemplatePermissions(elementPermissions);
    }

    const deferred = $.Deferred();
    deferred.resolve();
    return deferred.promise();
  },

  _setTemplate: function (pageData = {}) {
    this.page = Number.isInteger(pageData.page) ? pageData.page : 1;
    BaseView.prototype.setTemplate.call(this);
    INKIVE.DesignFacade.set('template', {
      restricted: {
        ...pageData,
        id: this.baseTemplate.encoded_id
      }
    });
  },

  toggleSet: function (value) {
    const $set = this.$el.find('.set');
    const isForced = typeof value !== 'undefined';

    isForced || $set.toggleClass('collapsed');
    isForced && $set.toggleClass('collapsed', !value);

    if ($set.is('.collapsed')) $set.removeAttr('style');
    else {
      if (!this.setLoaded) {
        this.setLoaded = true;
        this.initImageLoad($set);
      }

      $set.height(
        $set.find('ul').outerHeight(true) +
        $set.find('.line').outerHeight(true) +
        $set.find('.info').outerHeight(true)
      );
    }
  },

  initialize: function (options) {
    BaseView.prototype.initialize.call(this);

    this.width = options.width;
    this.format = options.format;
    this.baseTemplate = options.baseTemplate;

    UserInfoFactory.get().then(_.bind(function (userInfo) {
      this.canUse = hasRole('ROLE_PREMIUM') ||
        INKIVE.C.BOOK.book_type === INKIVE.C.BOOK_TYPE.TEMPLATE ||
        INKIVE.C.BOOK.book_type === INKIVE.C.BOOK_TYPE.RESTRICTED_DESIGN;

      this.render();
      INKIVE.Helpers.initTooltips(this.$el);
      this.initImageLoad(this.$el.find('.base'));

      this.isMultiPage() &&
      options.openSet &&
      this.toggleSet();

      function hasRole (role) {
        return _(userInfo.roles).contains(role);
      }
    }, this));
  },

  getTemplateRenderData: function () {
    const margin = 5;
    const ratio = this.format.width / this.format.height;
    const thumbHeight = this.width * (1 / ratio);
    const halfThumbHeight = ((this.width - margin) / 2) * (1 / ratio);
    const pages = this.baseTemplate?.pages || [];

    return {
      url: this.getThumbnailURL(),
      show_options: this.getShowOptions(),
      thumb_height: Math.floor(thumbHeight),
      can_use: this.canUse,
      page_id: pages[0]?.design_id,
      half_thumb_height: Math.floor(halfThumbHeight),
      is_set: this.isMultiPage(),
      name: this.baseTemplate.name || 'Multiple pages set',
      set: getAllPagesThumbnails.call(this),
      show_lock_icon: this.baseTemplate.is_premium && !INKIVE.Helpers.isWeBrandTemplate()
    };

    function getAllPagesThumbnails () {
      return pages.map(p => ({
        id: p.id,
        thumbnail: this.getThumbnailURL(p)
      }));
    }
  },

  getShowOptions: function () {
    if (INKIVE.C.PRINTING_TYPE && INKIVE.C.PRINTING_TYPE.max_pages === INKIVE.C.PRINTING_TYPE.min_pages) {
      return false;
    }

    return INKIVE.Helpers.isDesygnerProject() || INKIVE.Helpers.isWeBrandTemplate();
  },

  getThumbnailURL: function (page) {
    if (!page && this.baseTemplate && this.baseTemplate.cover) {
      return this.baseTemplate.cover;
    }
    if (!this.baseTemplate.pages) return '';
    page = page || this.baseTemplate.pages[0];
    if (!page) return '';
    const encodedDesign = md5(page.design_id);
    const bucketUrl = INKIVE.Helpers.getBucketUrl(this.baseTemplate.master_bucket);

    if (page.thumbnail) return page.thumbnail;

    return `${bucketUrl}/344/${this.baseTemplate.encoded_id}/${encodedDesign}.jpg?${page.last_mod}`;
  },

  displayLockedTemplateModal: function () {
    INKIVE.Helpers.displaySubscriptionModal('tool.templates.helper.description');
  },

  initImageLoad: function ($container) {
    $container.find('img').each(function () {
      this.onload = onImageLoad;
      this.src = $(this).data('src');
    });

    function onImageLoad () {
      $(this).removeAttr('height')
        .closest('.thumbnail.image')
        .removeClass('loading');
    }
  },

  isMultiPage: function () {
    return this.baseTemplate.is_multipage && this.baseTemplate.pages && this.baseTemplate.pages.length > 1;
  }
});
